export const ATTACHMENT_ACCEPT =
  ".jpg,.jpeg,.png,.bmp,.mp4,.mp3,.avi,.gif,.svg,.pdf,.xlsx,.xls,.xlsm,.xlsb,.doc,.docx,.ppt,.pptx,.odp,.csv";

// Mídias do tipo Estudo também aceitam pacotes compactados
export const STUDY_ATTACHMENT_ACCEPT = `${ATTACHMENT_ACCEPT},.zip`;

export const attachmentAcceptByMediaType = (mediaType) =>
  mediaType === "study" ? STUDY_ATTACHMENT_ACCEPT : ATTACHMENT_ACCEPT;

export const getFileNameFromHeaders = (headers) => {
  if (headers["filename"]) return headers["filename"];
  return headers["content-disposition"].split("filename=")[1].split(";")[0].replaceAll('"', "");
};
export const downloadFromResponse = (response, filename = null) => {
  const { data, headers, config } = response;
  if (!config.responseType || config.responseType !== "blob") {
    console.error('a request deve conter a config "responseType: `blob`,"');
    return;
  }
  const blob = new Blob([data], { type: headers["content-type"] });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = headers["content-disposition"] ? getFileNameFromHeaders(headers) : filename;
  a.click();
};

export const downloadFromUrl = (url, fileName = true) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
};
export const convertToFormData = (fileList) => {
  const formData = new FormData();
  Object.keys(fileList).forEach((key) => {
    formData.append(`files[]`, fileList[key]);
  });
  return formData;
};

export const sumFileListSize = (arrFileList) => {
  // return mb unit
  const sum = arrFileList.reduce((acc, file) => {
    acc += file.size;
    return acc;
  }, 0);
  return (sum / (1024 * 1024)).toFixed(2);
};

function createFolderHierachy(foldersName, file, target) {
  const folderName = foldersName.splice(0, 1);

  if (target[folderName] === undefined) {
    target[folderName] = {
      files: [],
      childs: {},
    };
  }

  if (foldersName.length === 0) {
    target[folderName].files.push(file);
    return;
  }

  createFolderHierachy(foldersName, file, target[folderName].childs);
}

export const transformFolderFilesToObject = (fileList, filterMimes) => {
  const result = {};
  Object.values(fileList).forEach((file) => {
    const filterMimePass = filterMimes.length
      ? filterMimes.some((m) => file.type.includes(m))
      : true;
    if (!filterMimePass) return;

    const paths = file.webkitRelativePath.split("/");
    const subFoldersName = paths.slice(0, paths.length - 1);
    createFolderHierachy(subFoldersName, file, result);
  });
  return result;
};

export const getPreview = (file) => {
  return new Promise((res, rej) => {
    try {
      const fr = new FileReader();
      fr.readAsDataURL(file);
      fr.onload = () => res(fr.result);
    } catch (err) {
      rej(err);
    }
  });
};

export const isImage = (file) => {
  return ["png", "jpeg", "jpg", "gif", "svg"].includes(file.extension);
}

export const isPdf = (file) => {
  return ["pdf"].includes(file.extension);
}

export const resolveIcon = (type) => {
  switch (true) {
    case type.includes('pdf'):
      return 'mdi-file-pdf'
    case type.includes('word'):
      return 'mdi-file-word'
    case type.includes('excel'):
      return 'mdi-file-excel'
    case type.includes('powerpoint'):
      return 'mdi-file-powerpoint'
    case type.includes('audio'):
      return 'mdi-file-music'
    case type.includes('video'):
      return 'mdi-file-video'
    case type.includes('image'):
      return 'mdi-image-area'
    case type.includes('text'):
      return 'mdi-file-document'
    case type.includes('zip'):
      return 'mdi-folder-zip'
    case type.includes('json'):
      return 'mdi-code-json'
    default:
      return 'mdi-image-broken-variant'
  }
}
